import React, { useEffect, useRef, useState } from 'react'
import styles from './header.module.scss'
import cx from 'classnames'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ButtonDropDown from '../../../UiKitComponents/ButtonDropDown/ButtonDropDown'
import { setSelectedLanguage } from '../../../../redux/actions/metaData'
import {
  logOutUser,
  setUserDetails,
  setUserEmail,
} from '../../../../redux/actions/authActions'
import AccountDropDown from '../../../UiKitComponents/AccountDropDown'
import Summary from '../../../../icons/summary.svg'
import { getUserData } from '../../../../api/userApi'
import logOut from '../../../../redux/thunks/account/logOut'
import Details from '../../../NestedComponents/Option 1/Details'
import { setChallengeStep } from '../../../../redux/actions/challengeStaps'
import ArrowBack from '../../../../icons/arrow-left.svg'
import Logo from '../../../../icons/logo-white.svg'

const Header = () => {
  const dispatch = useDispatch()
  const { pathname } = window.location
  let navigate = useNavigate()
  const { selectedLanguage } = useSelector((state) => state.metadata)
  const accessToken = localStorage.getItem('accessToken')
  const [showDetails, setShowDetails] = useState(false)
  const from = location.state?.from
  const [windowWidth, setWindowWidth] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })
  const handleResize = () => {
    setWindowWidth({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize)

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  useEffect(() => {
    accessToken &&
      getUserData()
        .then((data) => {
          dispatch(setUserDetails(data))
        })
        .catch((err) => console.log(err))
  }, [])
  const handleBackClick = () => {
    if (from === '/settings') {
      navigate(`${from}`)
    } else {
      navigate('/')
      dispatch(setChallengeStep('startChallenge', { challengeStep: 2 }))
    }
  }
  const handleChangeLanguage = (value) => {
    dispatch(setSelectedLanguage(value))
    // i18next.changeLanguage(value).then(() => dispatch(setSelectedLanguage(value)))
    localStorage.setItem('language', value)
  }

  const handleLogoClick = () => {
    if (!localStorage.getItem('accessToken')) {
      navigate('/')
      dispatch(logOut())
    } else {
      navigate('/profile')
    }
  }

  const handleShow = () => {
    if (!showDetails) {
      setShowDetails(true)
    } else setShowDetails(false)
  }
  return (
    <header
      className={cx(styles.header, {
        [styles.sum]: pathname === '/startChallenge',
        [styles.pay]: pathname === '/payment',
      })}
    >
      {windowWidth.width <= 980 && pathname === '/payment' ? (
        <div>
          <img src={ArrowBack} alt="ArrowBack" onClick={handleBackClick} />
        </div>
      ) : (
        <span onClick={handleLogoClick}></span>
      )}
      {windowWidth.width < 1320 && pathname === '/startChallenge' && (
        <div>
          <span>
            <p>Summary</p>
            <img src={Summary} alt={Summary} onClick={handleShow} />
          </span>
          {!!showDetails && <Details />}
        </div>
      )}
      {windowWidth.width <= 980 && pathname === '/payment' && (
        <div>
          <span>
            <p>FLEXXI</p>
          </span>
        </div>
      )}
      {accessToken && (
        <div>
          <div>
            <AccountDropDown />
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
